import * as React from 'react';

import { LOOKUP_MODULE_NAME } from '../../LookupTable';

import './Checkbox.styles.scss';

const CHECKBOX_VALUE = {
  yes: 'Y',
  no: 'N'
};

const VALUES_MAP = {
  [CHECKBOX_VALUE.no]: CHECKBOX_VALUE.yes,
  [CHECKBOX_VALUE.yes]: CHECKBOX_VALUE.no
};

export const Checkbox = (props) => {
  const { value, defaultValue, index, id, metadata, onSave } = props;
  const possibleValues = Object.values(CHECKBOX_VALUE);
  const initialValue = value || defaultValue;
  const hasValidValue = possibleValues.includes(initialValue);
  const normalizedValue = hasValidValue ? initialValue : CHECKBOX_VALUE.no;
  const [savedValue, setSavedValue] = React.useState(normalizedValue);
  const [currentValue, setCurrentValue] = React.useState(normalizedValue);

  React.useEffect(() => {
    setSavedValue(normalizedValue);
    setCurrentValue(normalizedValue);
  }, [index, value, id]);

  const handleChange = React.useCallback(async (e) => {
    try {
      e.persist();

      const { value } = e.currentTarget.dataset;

      setCurrentValue(value)

      await onSave({
        index,
        id,
        value,
        metadata,
      });

      setSavedValue(value);
    } catch (err) {
      setCurrentValue(savedValue);
    }
  }, [currentValue, index, id, savedValue, onSave]);

  return (
    <div className="LookupTableCheckbox" data-value={VALUES_MAP[currentValue]} onClick={handleChange}>
      <input
        id={`${LOOKUP_MODULE_NAME}-checkbox--id-${id}--index-${index}`}
        type="checkbox"
        value={VALUES_MAP[currentValue]}
        checked={currentValue === CHECKBOX_VALUE.yes}
        readOnly
      />
    </div>
  );
};

Checkbox.defaultProps = {
  defaultValue: '',
};